export default __webpack_public_path__ + "resumen1.jpg";